import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';
class OrganizationService {
  baseUrl = 'organization';

  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  getCurrent = () => BaseService.get({ url: `${this.baseUrl}/current-organization-statistics` });
  getAvailableContentTypes = () => BaseService.get({ url: `${this.baseUrl}/available-content-types` });
  get = (id) => BaseService.get({ url: `${this.baseUrl}/get/${id}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  getSettings = () => BaseService.get({ url: `${this.baseUrl}/get-settings` });
  save = (organization) => BaseService.post({ url: `${this.baseUrl}/save`, data: organization });
  saveSettings = (settings) => BaseService.post({ url: `${this.baseUrl}/save-settings`, data: settings });
  testEmailConfig = (settings) => BaseService.post({ url: `${this.baseUrl}/test-email-config`, data: settings });
  create = (organizationWizard) => BaseService.post({ url: `${this.baseUrl}/create`, data: organizationWizard });
  getEmailTemplateList = () => BaseService.get({ url: `${this.baseUrl}/get-email-template-list` });
  getEmailTemplateLanguageList = () => BaseService.get({ url: `${this.baseUrl}/get-email-template-language-list` });
  getEmailTemplate = (language, fileName) => BaseService.get({ url: `${this.baseUrl}/email-template/${language}/${fileName}` });
  saveEmailTemplate = (template) => BaseService.post({ url: `${this.baseUrl}/save-email-template`, data: template });
  saveEmailSettings = (settings) => BaseService.post({ url: `${this.baseUrl}/save-email-settings`, data: settings });
  getLogo = (organizationId) => Utils.file.attachment.get(`${this.baseUrl}/logo/${organizationId}`);
}

export default new OrganizationService();
